module.exports = __webpack_public_path__ + "static/img/parallel-gateway.dfb4ebaf.svg";